import { Component } from 'react';
import Inline from '../Inline';
import { TreeList, Column as TColumn } from 'devextreme-react/tree-list';
import { apiGetP, apiPostP } from '../../GanjiTools';
import TablesTree from './TablesTree';
import { UniGrid } from '../UniGrid';
import FormDesignItem from './FormDesignItem';
import { DropDownButton, Item as DdbItem } from 'devextreme-react/drop-down-button';
import { Button, CheckBox, DateBox, Form, List, NumberBox, Popup, SelectBox, Switch, TextArea, TextBox } from 'devextreme-react';
import Space from '../Space';
import { ButtonItem, EmptyItem, GroupItem, Label, SimpleItem } from 'devextreme-react/form';
import FormFieldProps from './SimpleInputFieldProps';
import DatePicker from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import TimePickerHHMM from '../TimePicker';
import FormFieldValidations from './FormFieldValidations';
import MinimalButton from '../MinimalButton';
import FormSectionProps from './FormSectionProps';
import FontAwesomeIcon from '../utils/FontAwesomeIcon';
import ComplexInputFieldProps from './ComplexInputFieldProps';
import ComplexInputField from './ComplexInputField';

// FormFieldSetting.Types enum
const type_space = 0, type_simpleInput = 1, type_boxed_SectionBreak = 2, type_unBoxed_SectionBreak = 3, type_grid = 4, type_singleSelect = 5,
    type_multiSelect = 6, type_form = 7;

class FormBuilder extends Component {
    state = {
        focusedTable: {}, // { tableName, parentColName, groupColName, columns }
        tableKey: 1,
        form: {},
        positions: [],
        sectionPositions: [],
        formsKey: 1,
        dragsKey: 1,
        field: {},
        section: {},
        viewMode: 'design',
        //sections: []
    }

    onAddNewForm = () => {
        if (!(this.state._focusedTable?.tableName?.length > 0)) {
            window.notif('جدول را انتخاب کنید');
            return;
        }

        if (!(this.state._newFormName?.length > 0)) {
            window.notif('نام فرم نمی تواند خالی باشد');
            return;
        }

        this.state._focusedForm = { name: this.state._newFormName };

        apiPostP(`/api/form/buildNewForm/${this.state._focusedTable.tableName}`, this.state._newFormName)
            .catch(window.notif)
            .then(res => {
                let { error, form } = res ?? { error: 'No response.' };
                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }
                this.state._focusedTable.forms.push(form ?? {});
                this.setState({ newFormNamePopVisible: false, formsKey: this.state.formsKey + 1 });
            });
    }

    onFieldUpdated = f => {
        Object.assign(this.state.field, f);
        //this.state.dragsKey++;
        this.forceUpdate();
    }

    onComplexInputFieldUpdated = f => {
        var field = this.state.positions.find(x => x.id === f?.id);
        if (!field) {
            console.log('The field not found: ', f);
            return;
        }
        Object.assign(field, f);
        //this.state.dragsKey++;
        this.forceUpdate();
    }

    onSectionUpdated = s => {
        Object.assign(this.state.section, s);
        //this.state.dragsKey++;
        this.forceUpdate();
    }

    onValidationUpdated = (vld, field) => {
        if (!field)
            return;

        field.pa_Validation_Via_FK_Validation = vld;
        //Object.assign(this.state.field.pa_Validation_Via_FK_Validation, vld);
        this.forceUpdate();
    }

    borderStyle = {
        borderRight: '1px dashed white',
        borderBottom: '1px dashed white',
    }

    loadFormDataP = form => new Promise((resolve, reject) => {
        if (!(form?.id > 0)) {
            reject?.('Form not found. ');
            return;
        }

        apiGetP(`/api/form/fields?formId=${form.id}`)
            .catch(reject)
            .then(res => {
                let { error, positions, sectionPositions } = res ?? { error: 'No response.', positions: [], sectionPositions: [] };

                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }

                positions.forEach(p => {
                    if (p.type !== type_simpleInput)
                        p.pa_Validation_Via_FK_Validation ??= { id: 0 };
                    else
                        p.lookup = JSON.parse(p.tempCol ?? '{}')?.lookup;
                });

                console.log('positions: ', positions);
                console.log('sectionPositions: ', sectionPositions);

                resolve?.({ positions, sectionPositions });
            });
    });


    selectForm = () => {
        if (!(this.state._focusedForm?.name?.length > 0))
            if (this.state._focusedTable?.forms?.length === 1)
                this.state._focusedForm = this.state._focusedTable.forms[0];

        if (!(this.state._focusedForm?.name?.length > 0))
            window.notif('فرم را انتخاب کنید');
        else
            this.loadFormDataP(this.state._focusedForm)
                .catch(window.notif)
                .then(({ positions, sectionPositions }) => {
                    this.setState({
                        tablePopVisible: false,
                        form: this.state._focusedForm,
                        positions,
                        sectionPositions
                    })
                });
    }

    positioningOptions = { cellh: 40, cellw: 30, nrows: 15, ncols: 30, defColSpan: 9, minAcceptableSections: 10 };

    onSaveForm = whenDone => {
        let data = {
            form: this.state.form,
            positions: this.state.positions?.filter(
                x => x.type === type_simpleInput
                    || x.isSectionBreak && x.coordX1 <= this.positioningOptions.ncols
                    || x.isComplexInput && x.coordX1 <= this.positioningOptions.ncols)
        };

        console.log('Saving ', data);

        apiPostP('/api/form/save', data)
            .catch(window.notif)
            .then(res => {
                let { error, warning, form } = res ?? { error: 'No response.' };

                if (error?.length > 0) {
                    window.notif(error);
                    return;
                }

                if (warning?.length > 0)
                    console.log('Warning: ', warning);

                console.log('Form is saved. -> ', form);
                whenDone?.();
            });
    }

    setViewMode = viewMode => {
        this.state.viewMode = viewMode;

        if (viewMode === 'preview')
            this.onSaveForm(this.selectForm);
        else
            this.forceUpdate();
    }

    static renderComponent(component, propsJsn, additionalProps) {
        let props = JSON.parse(propsJsn ?? '{}');

        switch (component?.toLowerCase()) {
            case 'textbox':
                return <TextBox {...props} {...additionalProps} />;
            case 'textarea':
                return <TextArea {...props} {...additionalProps} />;
            case 'numberbox':
                return <NumberBox {...props} {...additionalProps} />;
            case 'checkbox':
                return <CheckBox {...props} {...additionalProps} />;
            case 'switch':
                return <Switch {...props} {...additionalProps} />;
            case 'selectbox':
                return <SelectBox {...props} {...additionalProps} />;
            case 'datebox':
                return <DateBox {...props} {...additionalProps} />;
            case 'datepicker':
                return <DatePicker {...props} {...additionalProps} />;
            case 'timepicker':
                return <TimePicker {...props} {...additionalProps} />;
            case 'timepickerhhmm':
                return <TimePickerHHMM {...props} {...additionalProps} />
            case 'button':
                return <Button {...props} {...additionalProps} />;
            default:
                return <span>(Invalid component:{component})</span>;
        }
    }

    fillSections = () => {
        this.state.positions ??= [];
        let nSections = this.state.positions.filter(x => x.isSectionBreak)?.length ?? 0;

        for (let i = nSections; i < this.positioningOptions.minAcceptableSections; i++)
            this.state.positions.push({
                name: '__section_' + i,
                type: type_boxed_SectionBreak,
                caption_FA: 'سکشن جدید',
                coordY1: 0,
                coordX1: 1 + this.positioningOptions.ncols,
                colSpan: this.positioningOptions.defColSpan,
                isSectionBreak: true,
            });
    }

    fillComplexInputs = () => {
        this.state.positions ??= [];
        let nComplexInputs = this.state.positions.filter(x => x.isComplexInput)?.length ?? 0;

        for (let i = nComplexInputs; i < this.positioningOptions.minAcceptableSections; i++)
            this.state.positions.push({
                name: '__complexInput_' + i,
                type: type_grid,
                caption_FA: 'ورودی جدید',
                coordY1: 2,
                coordX1: 1 + this.positioningOptions.ncols,
                colSpan: this.positioningOptions.defColSpan,
                isComplexInput: true,
            });
    }

    componentDidMount() {
    }

    rederSection = section => {
        let { cellh, cellw, nrows, ncols, defColSpan } = this.positioningOptions;

        section.isHidden = section.coordX1 > ncols;
        section.colSpan = section.coordX1 > ncols ? defColSpan : ncols;
        section.coordX1 = !section.isHidden && section.coordX1 <= ncols ? 0 : ncols + 1;
        section.coordY1 = !section.isHidden && section.coordX1 <= ncols ? section.coordY1 : 0;

        return (
            <FormDesignItem sid={section.name} key={section.name} text={section.caption_FA} rtl
                width={section.colSpan * cellw - 2} style={{ height: cellh - 2 + 'px' }}
                right={(defColSpan + 1 + section.coordX1) * cellw}
                top={section.coordY1 * cellh} cat='section'

                onSettings={() => this.setState({ section, sectionSettingsPopVisible: true })}

                onHide={() => {
                    section.coordX1 = ncols + 1;
                    section.colSpan = defColSpan;
                    section.coordY1 = 0;
                    this.setState({ dragsKey: this.state.dragsKey + 1 });
                }}

                onDragged={(x, y, sid, elem) => {
                    section.coordX1 = Math.round(x / cellw) - 1 - defColSpan;
                    section.coordY1 = Math.round(y / cellh);

                    if (section.coordX1 <= ncols) {
                        section.coordX1 = 0;
                        section.colSpan = ncols;
                    }
                    else {
                        section.coordX1 = ncols + 1;
                        section.coordY1 = 0;
                        section.colSpan = defColSpan;
                    }
                    this.setState({ dragsKey: this.state.dragsKey + 1 });
                }}
            />
        );
    }

    renderSimpleInput = field => {
        let { cellh, cellw, nrows, ncols, defColSpan } = this.positioningOptions;
        let yCounter = -1;

        if ((field.coordY1 >= 0 ? field.coordY1 : -1) < 0)
            field.coordY1 = ++yCounter;

        if (!(field.coordX1 >= 0))
            field.coordX1 = -defColSpan - 1;

        if (!(field.colSpan > 0))
            field.colSpan = defColSpan;

        return (
            <FormDesignItem sid={field.name} text={field.caption_FA} key={field.name} rtl
                width={field.colSpan * cellw - 2} style={{ height: cellh - 2 + 'px' }}
                right={(defColSpan + 1 + field.coordX1) * cellw} cat='simpleInput'
                top={field.coordY1 * cellh}

                onDragged={(x, y, sid, elem) => {
                    field.coordX1 = Math.round(x / cellw) - 1 - defColSpan;
                    field.coordY1 = Math.round(y / cellh);
                    while (this.state.positions.find(x => x.coordX1 <= ncols && x.type === type_boxed_SectionBreak && x.coordY1 == field.coordY1 && field.coordX1 >= 0))
                        field.coordY1++;
                    this.setState({ dragsKey: this.state.dragsKey + 1 });
                }}
                onResized={(w, h, sid) => {
                    field.colSpan = Math.round(w / cellw);
                }}
                onSettings={() => this.setState({ field, fieldSettingsPopVisible: true })}
                onValidation={() => this.setState({ field, fieldValidationsPopVisible: true })}
            />
        );
    }

    renderComplexInput = complexInputField => {
        let { cellh, cellw, nrows, ncols, defColSpan } = this.positioningOptions;
        let yCounter = -1;
        complexInputField.isHidden = complexInputField.coordX1 > ncols;

        if (complexInputField.coordX1 > ncols)
            complexInputField.colSpan = defColSpan;

        if (!(complexInputField.rowSpan > 0))
            complexInputField.rowSpan = 1;

        complexInputField.coordX1 = !complexInputField.isHidden && complexInputField.coordX1 <= ncols ? complexInputField.coordX1 : ncols + 1;
        complexInputField.coordY1 = !complexInputField.isHidden && complexInputField.coordX1 <= ncols ? complexInputField.coordY1 : 2;

        return (
            <FormDesignItem sid={complexInputField.name} key={complexInputField.name} text={complexInputField.caption_FA} rtl
                width={complexInputField.colSpan * cellw - 2}
                height={complexInputField.rowSpan * cellh - 2}
                right={(defColSpan + 1 + complexInputField.coordX1) * cellw}
                top={complexInputField.coordY1 * cellh}
                cat='complexInput'

                onSettings={() => this.setState({ complexInputField, complexInputFieldSettingsPopVisible: true })}

                onHide={() => {
                    complexInputField.coordX1 = ncols + 1;
                    complexInputField.colSpan = defColSpan;
                    complexInputField.coordY1 = 2;
                    this.setState({ dragsKey: this.state.dragsKey + 1 });
                }}

                onResized={(w, h, sid) => {
                    complexInputField.colSpan = Math.round(w / cellw);
                    complexInputField.rowSpan = Math.round(h / cellh);

                    if (complexInputField.rowSpan < 1)
                        complexInputField.rowSpan = 1;
                }}

                onDragged={(x, y, sid, elem) => {
                    complexInputField.coordX1 = Math.round(x / cellw) - 1 - defColSpan;
                    complexInputField.coordY1 = Math.round(y / cellh);

                    if (complexInputField.coordX1 > ncols) {
                        complexInputField.coordX1 = ncols + 1;
                        complexInputField.coordY1 = 2;
                        complexInputField.colSpan = defColSpan;
                    }
                    this.setState({ dragsKey: this.state.dragsKey + 1 });
                }}
            />
        )
    }

    renderGround = () => {
        let { cellh, cellw, nrows, ncols, defColSpan } = this.positioningOptions;
        let yCounter = -1;

        return (
            <div style={{
                width: ncols * cellw + 'px', height: nrows * cellh + 'px', background: '#d2e8f5', direction: 'rtl',
                position: 'absolute', top: '0px', right: (1 + defColSpan) * cellw + 'px',
            }}
            >
                {
                    Array.from({ length: nrows }, (_, i) => i + 1).map(i => (
                        Array.from({ length: ncols }, (_, j) => j + 1).map(j => (
                            <div key={i * 100 + j}
                                style={{
                                    ...this.borderStyle,
                                    position: 'absolute',
                                    top: (i - 1) * cellh + 'px',
                                    left: (j - 1) * cellw + 'px',
                                    width: cellw - 1 + 'px',
                                    height: cellh - 1 + 'px',
                                }}>
                                &nbsp;
                            </div>
                        ))
                    ))
                }
            </div>
        );
    }

    renderPreview = () => {
        let { cellh, cellw, nrows, ncols, defColSpan } = this.positioningOptions;
        let yCounter = -1;

        return (
            <div style={{ padding: '2rem', border: '1px solid gray', margin: '1rem' }} key={`cprvf_${this.state.dragsKey}_${this.state.viewMode}`}
            >
                {this.state.sectionPositions?.map(sp => {
                    let sec = sp?.section ?? { name: '' };
                    let positions = sp?.positions ?? [];
                    if (!(sp.positions?.find(p => p.colSpan > 0 && p.isHidden !== true)))
                        return (<></>);

                    let jsStyle = {};
                    sec.jsStyle ??= '({})';
                    sec.jsStyle = sec.jsStyle.trim();

                    if (!sec.jsStyle.startsWith('({'))
                        if (sec.jsStyle.startsWith('{'))
                            sec.jsStyle = `(${sec.jsStyle})`;
                        else
                            sec.jsStyle = `({${sec.jsStyle}})`;

                    try { jsStyle = eval(sec.jsStyle); }
                    catch (e) { console.log('! could not evaluate jsStyle: ', sec.jsStyle, e) }

                    return (
                        <div //className={sec.className ?? ''}
                            style={{
                                width: 'auto', padding: '1rem', borderRadius: '1rem',
                                background: '#d3d3d352', marginTop: '1rem',
                                ...jsStyle
                            }}
                            key={`prvsecformcnt_${this.state.dragsKey}_${this.state.viewMode}_${sec.name ?? ''}`}
                        >
                            <Form key={`prvsecform_${this.state.dragsKey}_${this.state.viewMode}_${sec.name ?? ''}`}
                                colCount={ncols} width='100%' rtlEnabled
                            >
                                {sec.caption_FA?.length > 0 &&
                                    <SimpleItem colSpan={ncols} key={`pfi_sectitle_${this.state.dragsKey}_${sec.name ?? ''}`}
                                    >
                                        <div style={{ width: '100%', fontSize: '0.8em', fontWeight: 'bolder', opacity: '70%' }}>
                                            <FontAwesomeIcon icon='circle-dot' style={{ opacity: '70%', iconSize: '0.5em' }} />
                                            <Space width='0.5em' />
                                            <span>{sec.caption_FA ?? ''}</span>
                                        </div>
                                    </SimpleItem>
                                }

                                {positions?.filter(p => p.colSpan > 0 && p.isHidden !== true)
                                    ?.map(p => p.isSimpleInput
                                        ?
                                        <SimpleItem colSpan={p.colSpan} key={`pfi_${p.order}_${this.state.dragsKey}_${sec.name ?? ''}`}
                                        >
                                            <Label text={p.caption_FA ?? p.name} />
                                            {FormBuilder.renderComponent(p.component, p.componentProps,
                                                { readOnly: p.isReadonly === true }
                                            )}
                                        </SimpleItem>
                                        : p.isComplexInput ?
                                            <SimpleItem colSpan={p.colSpan}
                                            >
                                                {/* <Label text='under construction...' /> */}
                                                <ComplexInputField />
                                            </SimpleItem>
                                            :
                                            <EmptyItem colSpan={p.colSpan} key={`pfis_${p.order}_${this.state.dragsKey}_${sec.name ?? ''}`}
                                            />
                                    )}
                            </Form>
                        </div>
                    );
                })}
            </div>
        );
    }


    render() {
        let { cellh, cellw, nrows, ncols, defColSpan } = this.positioningOptions;
        let yCounter = -1;

        this.fillSections();
        this.fillComplexInputs();

        let designables = this.state.viewMode !== 'design' ? [] : this.state.positions ?? [];

        return (
            <>
                <div style={{
                    margin: '5px 10px',
                    padding: '5px',
                    width: '95%',
                    background: '#0001',
                    border: 'none',
                    borderRadius: '10px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <span>عنوان فرم:</span>
                    <Space />
                    <TextBox rtlEnabled width='25%'
                        value={this.state._focusedForm?.name}
                        onValueChanged={e => this.setState({ _focusedForm: { ...this.state._focusedForm, name: e.value } })}
                    />
                    <Button icon='save' onClick={() => this.setState({ form: { ...this.state.form, name: this.state._focusedForm?.name } })} />
                </div>

                <Inline spacing='10px' style={{ justifyContent: this.state.viewMode === 'preview' ? 'center' : 'start' }}
                    key={'inlinecnt_' + this.state.viewMode}
                >
                    <div style={{
                        width: (1 + defColSpan) * cellw + ncols * cellw - 2 + 'px', height: nrows * cellh - 2 + 'px',
                        direction: 'rtl', position: 'relative', //background: 'yellow'
                    }}
                    >
                        <div style={{ width: '100%', height: 'inherit', direction: 'rtl' }} key={'ff' + this.state.dragsKey}
                        >
                            {
                                designables.filter(x => x.isSectionBreak).map(this.rederSection)
                            }
                            {
                                designables.filter(x => x.isComplexInput).map(this.renderComplexInput)
                            }
                            {
                                designables.filter(x => x.isSimpleInput).map(this.renderSimpleInput)
                            }
                            {
                                this.state.viewMode === 'design' ? this.renderGround() : this.renderPreview()
                            }
                        </div>
                    </div>
                </Inline>

                <Inline spacing='1rem' style={{ marginTop: '50vh', width: '100%', justifyContent: 'center', position: 'fixed', bottom: '50px' }}
                >
                    <DropDownButton key={'btnViewMode_' + this.state.viewMode}
                        rtlEnabled width='15rem'
                        text={this.state.viewMode === 'preview' ? 'پیش نمایش' : 'طراحی'}
                        showArrowIcon icon={this.state.viewMode === 'preview' ? 'photo' : 'edit'}
                        selectedItemKey={this.state.viewMode}
                    >
                        <DdbItem text='طراحی' icon='edit' key='design' onClick={() => this.setViewMode('design')} />
                        <DdbItem text='پیش نمایش' icon='photo' key='preview' onClick={() => this.setViewMode('preview')} />
                    </DropDownButton>

                    <Button text='بارگذاری / ایجاد' icon='folder' width='15rem' type='success' rtlEnabled
                        onClick={() => this.setState({ tablePopVisible: true })}
                    />
                    <Button text='ذخیره' icon='save' width='15rem' type='success' rtlEnabled
                        onClick={() => this.onSaveForm()}
                    />
                </Inline>

                <Popup title='انتخاب فرم' rtlEnabled showCloseButton={false}
                    width='auto' height='auto'
                    visible={this.state.tablePopVisible}
                    onHidden={() => this.setState({ tablePopVisible: false })}
                >
                    <Inline spacing='3rem' style={{ position: 'relative', direction: 'rtl' }}
                    >
                        <div style={{ width: '15rem' }}
                        >
                            <div style={{ direction: 'rtl', width: '15rem', margin: '0.5em 0' }}
                            >فرم ها:
                            </div>

                            <List key={`formsList_${this.state.formsKey}`} dataSource={this.state._focusedTable?.forms}
                                displayExpr='name' height={300}
                                selectedItem={this.state._focusedForm}
                                focusStateEnabled={false} selectionMode='single'
                                onItemClick={e => this.setState({ _focusedForm: e.itemData })}
                                noDataText='(بدون فرم)'
                            />

                            <Button text='افزودن فرم جدید' icon='plus' width='100%' rtlEnabled
                                onClick={() => {
                                    if (!(this.state._focusedTable?.tableName?.length > 0)) {
                                        window.notif('جدول را انتخاب کنید');
                                        return;
                                    }
                                    this.setState({ newFormNamePopVisible: true });
                                }}
                            />

                            <div style={{ height: '1rem' }}
                            >
                                &nbsp;
                            </div>

                            <Button icon='check' type='success' text='قبول' width='100%' rtlEnabled
                                onClick={() => this.selectForm()}
                            />

                            <div style={{ height: '5px' }}>&nbsp;</div>
                            <Button icon='close' type='danger' text='رد' width='100%' rtlEnabled
                                onClick={() => this.setState({ tablePopVisible: false })}
                            />
                        </div>

                        <TablesTree height={400} width='20rem' rtlEnabled={false} formBased
                            onFocusedTableChanged={_focusedTable => {
                                this.setState({ _focusedTable })
                            }}
                        />

                    </Inline>
                </Popup>

                <Popup title='نام فرم' rtlEnabled visible={this.state.newFormNamePopVisible} width='30rem' height='auto'
                    onHidden={() => this.setState({ newFormNamePopVisible: false })}
                >
                    <Form rtlEnabled colCount={60}>
                        <SimpleItem colSpan={60}>
                            <Label text='نام فرم' />
                            <TextBox rtlEnabled value={this.state._newFormName}
                                onValueChanged={e => this.setState({ _newFormName: e.value })}
                            />
                        </SimpleItem>

                        <EmptyItem colSpan={60} />

                        <ButtonItem colSpan={30} buttonOptions={{
                            text: 'قبول', icon: 'check', width: '90%', type: 'success',
                            onClick: () => this.onAddNewForm()
                        }}
                        />

                        <ButtonItem colSpan={30} buttonOptions={{
                            text: 'رد', icon: 'close', width: '90%', type: 'danger',
                            onClick: () => this.setState({ newFormNamePopVisible: false })
                        }} />
                    </Form>
                </Popup>

                <Popup rtlEnabled visible={this.state.sectionSettingsPopVisible} title={`تنظیمات سکشن ${this.state.section?.name} (${this.state.section?.caption_FA})`}
                    width='auto' height='auto'
                    onHidden={() => this.setState({ sectionSettingsPopVisible: false })}
                >
                    <FormSectionProps key={`fsp_${this.state.section?.id}`} section={this.state.section}
                        onOk={sec => this.setState({ sectionSettingsPopVisible: false }, () => this.onSectionUpdated(sec))}
                        onCancel={() => this.setState({ sectionSettingsPopVisible: false })}
                    />
                </Popup>

                <Popup rtlEnabled visible={this.state.fieldSettingsPopVisible} title={`تنظیمات فیلد ${this.state.field?.name} (${this.state.field?.caption_FA})`}
                    width='auto' height='auto'
                    onHidden={() => this.setState({ fieldSettingsPopVisible: false })}
                >
                    <FormFieldProps key={`ffp_${this.state.field?.id}`} field={this.state.field}
                        onOk={fld => this.setState({ fieldSettingsPopVisible: false }, () => this.onFieldUpdated(fld))}
                        onCancel={() => this.setState({ fieldSettingsPopVisible: false })}
                    />
                </Popup>

                <Popup rtlEnabled visible={this.state.complexInputFieldSettingsPopVisible}
                    title={`تنظیمات فیلد ${this.state.complexInputField?.name} (${this.state.complexInputField?.caption_FA})`}
                    width='auto' height='auto'
                    onHidden={() => this.setState({ complexInputFieldSettingsPopVisible: false })}
                >
                    <ComplexInputFieldProps key={`ciffp_${this.state.complexInputField?.id}`} complexInputField={this.state.complexInputField}
                        onOk={fld => this.setState({ complexInputFieldSettingsPopVisible: false }, () => this.onComplexInputFieldUpdated(fld))}
                        onCancel={() => this.setState({ complexInputFieldSettingsPopVisible: false })}
                    />
                </Popup>

                <Popup rtlEnabled visible={this.state.fieldValidationsPopVisible} title={`اعتبارسنجی فیلد ${this.state.field?.name} (${this.state.field?.caption_FA})`}
                    width='auto' height='auto'
                    onHidden={() => this.setState({ fieldValidationsPopVisible: false })}
                >
                    <FormFieldValidations key={`ffv_${this.state.field?.id}`} validation={this.state.field?.pa_Validation_Via_FK_Validation ?? { id: 0 }} //field={this.state.field}
                        onOk={vld => this.setState({ fieldValidationsPopVisible: false }, () => this.onValidationUpdated(vld, this.state.field))}
                        onCancel={() => this.setState({ fieldValidationsPopVisible: false })}
                    />
                </Popup>
            </>
        );
    }
}

export default FormBuilder;